import {Button} from "react-bootstrap";
import React, {useContext, useEffect, useState} from "react";
import * as api from "../../api/skyduck";
import {CardWrapper} from "../common/card";
import Row from "react-bootstrap/Row";
import {JumpForm} from "../form/jump-form";
import {UnitsContext} from "../../index";
import {FormsHolder, isFormsReadyToUpload, mapFormsForAPI} from "../form/form-holder";
import {ImportJumps} from "./import-jumps";
import Modal from "react-bootstrap/Modal";
import Container from "react-bootstrap/Container";
import * as ReactGA from "react-ga";
import Col from "react-bootstrap/Col";

function DiscardJumpsButton(props) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            {
                props.showButton
                    ? <Button variant="outline-danger" onClick={handleShow}>
                        Discard jumps
                    </Button>
                    : null
            }

            <Modal show={show}
                   onHide={handleClose}
                   aria-labelledby="contained-modal-title-vcenter"
                   centered>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Discard jumps
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <p>You are about to discard all entered jumps.</p>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="outline-danger" onClick={() => {
                        props.deleteAllForms();
                        handleClose();
                    }}>
                        Confirm
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

function UploadButtons(props) {
    return (
        <>
            <Button className="mr-2" variant="primary" onClick={() => {
                props.addForm();
                props.scrollToBottom();
                ReactGA.event({
                    category: 'User',
                    action: 'Added new jump to upload'
                });
            }}>Add jump</Button>
            <ImportJumps addForm={props.addForm}/>
        </>
    )
}

function UploadJumpsButton(props) {
    const [isLoading, setLoading] = useState(false);

    const units = useContext(UnitsContext).units;

    useEffect(() => {
        if (isLoading) {
            if (isFormsReadyToUpload(props.state.jumps)) {
                api.uploadJumps(mapFormsForAPI(props.state.jumps), units).then(() => {
                    props.deleteAllForms();
                    setLoading(false);
                    ReactGA.event({
                        category: 'User',
                        action: 'Uploaded new jumps'
                    });
                })
            } else {
                props.validateForms();
                setLoading(false);
            }
        }
    }, [isLoading]);

    const handleClick = () => setLoading(true);

    return (
        <Button
            className="mr-2"
            variant="primary"
            disabled={isLoading || !props.canUpload}
            onClick={!isLoading ? handleClick : null}
        >
            {isLoading ? 'Uploading...' : 'Upload jumps'}
        </Button>
    );
}

export class Upload extends FormsHolder {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <>
                {
                    this.state.jumps.map((jump, index) => (
                        <div className="mb-3" key={index}>
                            <CardWrapper key={jump}>
                                <Row>
                                    <Col className="col align-self-end">
                                        <button type="button" className="close" onClick={() => this.deleteForm(index)}>
                                            <span aria-hidden="true">×</span>
                                            <span className="sr-only">Delete</span>
                                        </button>
                                    </Col>
                                </Row>
                                <Row>
                                    <JumpForm index={index} {...jump}
                                              updateDictionaries={this.updateDictionaries}
                                              dictionaries={this.state.dictionaries}
                                              handleFormChange={this.changeForm}/>
                                </Row>
                            </CardWrapper>
                        </div>
                    ))
                }

                <div className="mt-5">
                    <UploadButtons {...this} scrollToBottom={this.props.scrollToBottom}/>
                </div>

                <p className="mt-3">Jumps to upload: {this.state.jumps.length}</p>
                <UploadJumpsButton
                    canUpload={this.state.jumps.length > 0}
                    {...this}
                />
                <DiscardJumpsButton showButton={this.state.jumps.length > 0} {...this}/>
            </>
        )
    }
}